import { messageService } from './api';

// Custom event para simular Socket.io
const chatEvents = {
  listeners: {},
  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  },
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  },
  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  }
};

class ChatService {
  constructor() {
    this.connected = false;
    this.handlers = {
      onMessage: () => {},
      onJoinRoom: () => {},
      onUserJoined: () => {},
      onError: () => {}
    };
    this.currentRoom = null;
  }

  // Conectar al servicio de chat
  connect() {
    if (this.connected) return;
    
    console.log('Conectado a WebSocket (simulado)');
    this.connected = true;
    
    // Configurar listeners para los eventos simulados
    chatEvents.on('chat message', (message) => {
      console.log('Mensaje recibido:', message);
      this.handlers.onMessage(message);
    });
    
    chatEvents.on('room joined', (data) => {
      console.log('Unido a sala:', data);
      this.handlers.onJoinRoom(data);
    });
    
    chatEvents.on('user joined', (data) => {
      console.log('Usuario unido:', data);
      this.handlers.onUserJoined(data);
    });
    
    chatEvents.on('error', (error) => {
      console.error('Error de WebSocket:', error);
      this.handlers.onError(error);
    });
  }

  // Desconectar del servicio
  disconnect() {
    if (!this.connected) return;
    
    // Limpiar listeners
    chatEvents.off('chat message');
    chatEvents.off('room joined');
    chatEvents.off('user joined');
    chatEvents.off('error');
    
    this.connected = false;
    this.currentRoom = null;
    console.log('Desconectado de WebSocket (simulado)');
  }

  // Unirse a una sala de chat
  joinRoom(roomId) {
    if (!this.connected) {
      this.connect();
    }
    
    this.currentRoom = roomId;
    
    // Emitir evento simulado de unirse a sala
    setTimeout(() => {
      chatEvents.emit('room joined', { room: roomId, message: 'Te has unido a la sala de chat' });
    }, 100);
    
    console.log(`Unido a sala: ${roomId} (simulado)`);
  }

  // Enviar un mensaje de chat
  sendMessage(sender, receiver, message) {
    if (!this.connected) {
      this.connect();
    }
    
    const messageData = {
      _id: Date.now().toString(),
      sender,
      receiver,
      message,
      sentAt: new Date().toISOString()
    };
    
    // Simular envío por WebSocket
    setTimeout(() => {
      chatEvents.emit('chat message', messageData);
    }, 200);
    
    // También guardar en la base de datos mediante llamada API
    return messageService.sendMessage({ sender, receiver, message })
      .then(() => messageData);
  }

  // Obtener historial de mensajes
  getChatHistory(userId1, userId2) {
    // Crear ID de sala ordenando los IDs para que sea consistente
    const roomId = [userId1, userId2].sort().join('-');
    return messageService.getChatHistory(roomId);
  }

  // Configurar manejadores de eventos
  setHandlers(handlers) {
    this.handlers = { ...this.handlers, ...handlers };
  }
}

// Crear una instancia única para usar en toda la aplicación
const chatService = new ChatService();

export default chatService; 